// extracted by mini-css-extract-plugin
export default {"submitButton":"submitButton__mDhn_UDi","footerContainer":"footerContainer__KBdZM9SU"};